<template>
  <div>
    <nav
      class="navbar navbar-expand"
      id="headerNavTab"
      :class="$route.path=='/vendor/vendorOrderListing'
      || $route.path=='/vendor/vendorProductListing'?'dashboard-nav':'vendor-nav'"
    >
      <div class="text-center brand-img-cont">
        <div id="wp_vendor_login" class="navbrand">
          <router-link
            to="/"
            id="headerNavTabThreeLink1-logo-img-link"
												data-test="headerNavTabThreeLink1"
          >
            <img
              src="@/assets/img/neobank.png"
              alt="Site Logo"
              id="headerNavTabThreeImg1-logo-img"
														data-test="headerNavTabThreeImg1"
            >
          </router-link>
        </div>
      </div>
      <div class="ml-auto text-right">
        <a
          href
          class="text-white"
          v-if="((auth && $route.path.includes('vendor')) || $route.path.includes('/agent/'))"
          @click.prevent="logOut()"
          id="headerNavTabThreeLogoutLink-userlogout-mob-link"
										data-test="headerNavTabThreeLogoutLink"
        >Logout</a>
      </div>
      <!-- <div class="login-box">
<div class="input-group">
  <div class="input-group-prepend">
    <span class="input-group-text">Login</span>
  </div>
  <input type="text" aria-label="username" placeholder="Username" class="form-control">
  <input type="password" aria-label="password" placeholder="Password" class="form-control">
    <div class="input-group-append">
    <button class="btn btn-outline-secondary" type="button" id="button-addon2">Login</button>
  </div>
</div>
      </div> -->
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { vendorApis } from '@/services/ApiServices/vendorApis'
import { agentApis } from '@/services/ApiServices/agentApis'

export default {
	data () {
		return {
			auth: false
		}
	},
	computed: {
		...mapGetters('cart', ['getOrderCart']),
		...mapGetters('cart', ['getCartCount']),
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('vendor', ['isVendorAuthenticated'])
	},
	mounted () {
		this.auth = this.isVendorAuthenticated
	},
	watch: {
		isVendorAuthenticated () {
			this.auth = this.isVendorAuthenticated
		}
	},
	methods: {
		logOut () {
			if (this.$route.path.includes('vendor')) {
				vendorApis.vendorLogOut().then(() => {
					this.$router.push('/vendorLogin')
				})
			} else if (this.$route.path.includes('/agent/')) {
				agentApis.agentLogOut()
			}
		}
	}
}
</script>
